import { __awaiter } from '../../node_modules/tslib/tslib.es6.js';
import { isServerSideCheckoutEligible } from '../../utils/productUtils.js';
import { getRetailerFromId, formatMoney } from '../../utils/stringUtils.js';
import numeral from 'numeral';
import React__default, { useState } from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '../../Components/ui/carousel.js';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/CheckMarkIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';
import { Button } from '../../Components/Button/Button.js';
import '../../Components/Button/CustomDtcBagButton.js';

// Sub-component for product image carousel
const ProductImageCarousel = ({ images, productTitle }) => {
    if (images.length === 0)
        return null;
    // Square container with light gray background matching Figma design
    // Note: Grid column width (280px) is controlled by .featured-product-grid CSS class
    const imageContainerClass = 'tw:relative tw:w-full tw:aspect-square tw:flex tw:items-center tw:justify-center tw:bg-[#f7f7f7] tw:overflow-hidden';
    const imageWrapperClass = 'tw:w-full tw:h-full tw:flex tw:items-center tw:justify-center tw:p-4';
    const imageClass = 'tw:max-w-full tw:max-h-full tw:w-auto tw:h-auto tw:object-contain';
    if (images.length === 1) {
        return (React__default.createElement("div", { className: imageContainerClass },
            React__default.createElement("div", { className: imageWrapperClass },
                React__default.createElement("img", { src: images[0], alt: productTitle, className: imageClass, loading: "eager" }))));
    }
    return (React__default.createElement("div", { className: `${imageContainerClass} tw:group` },
        React__default.createElement(Carousel, { opts: {
                align: 'start',
                loop: false,
            }, className: "tw:w-full tw:h-full" },
            React__default.createElement(CarouselContent, { className: "tw:h-full" }, images.map((imageUrl, idx) => (React__default.createElement(CarouselItem, { key: idx, className: "tw:h-full" },
                React__default.createElement("div", { className: imageWrapperClass },
                    React__default.createElement("img", { src: imageUrl, alt: `${productTitle} - ${idx + 1}`, className: imageClass, loading: idx === 0 ? 'eager' : 'lazy' })))))),
            images.length > 1 && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(CarouselPrevious, { className: "tw:left-2 tw:size-7 tw:bg-background/90 tw:backdrop-blur-sm tw:border tw:shadow-md tw:opacity-0 tw:group-hover:opacity-100 tw:transition-opacity" }),
                React__default.createElement(CarouselNext, { className: "tw:right-2 tw:size-7 tw:bg-background/90 tw:backdrop-blur-sm tw:border tw:shadow-md tw:opacity-0 tw:group-hover:opacity-100 tw:transition-opacity" }))))));
};
const StarIcon = (props) => {
    return (React__default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, props),
        React__default.createElement("path", { d: "M15.9773 6.07492C15.9519 5.98927 15.9029 5.9125 15.836 5.85339C15.769 5.79428 15.6867 5.75522 15.5986 5.7407L10.6386 4.98515L8.41638 0.274035C8.38041 0.192515 8.32151 0.12321 8.24687 0.074557C8.17222 0.0259036 8.08504 0 7.99593 0C7.90683 0 7.81965 0.0259036 7.745 0.074557C7.67035 0.12321 7.61146 0.192515 7.57549 0.274035L5.35327 4.98515L0.393265 5.7407C0.305129 5.75522 0.222865 5.79428 0.155895 5.85339C0.088925 5.9125 0.0399567 5.98927 0.0145984 6.07492C-0.012732 6.16181 -0.0161775 6.25445 0.00462334 6.34313C0.0254242 6.43181 0.0697048 6.51325 0.132821 6.57892L3.73371 10.2465L2.88393 15.4251C2.86874 15.5147 2.87808 15.6067 2.91094 15.6913C2.94381 15.776 2.99898 15.8502 3.0706 15.906C3.14023 15.9597 3.22403 15.9918 3.31168 15.9984C3.39934 16.0051 3.48702 15.9859 3.56393 15.9434L8.00038 13.498L12.4368 15.9434C12.5137 15.9859 12.6014 16.0051 12.6891 15.9984C12.7767 15.9918 12.8605 15.9597 12.9302 15.906C13.0018 15.8502 13.0569 15.776 13.0898 15.6913C13.1227 15.6067 13.132 15.5147 13.1168 15.4251L12.267 10.2465L15.859 6.5807C15.9225 6.51486 15.9669 6.43311 15.9878 6.34408C16.0086 6.25505 16.0049 6.16206 15.9773 6.07492Z", fill: "#ED792F" })));
};
const FeaturedProductWidget = ({ product, onAddToCart, onOpenCart }) => {
    const [isAddingToBag, setIsAddingToBag] = useState(false);
    const images = product.imageUrls || [];
    const featureBullets = product.featureBullets || [];
    const getReviewRatingValue = () => {
        const formatValue = (value) => Math.round(value * 10) / 10;
        if (product.reviewsRating && product.reviewsRating > 0) {
            return formatValue(product.reviewsRating);
        }
        if (product.reviewsAverageRating && product.reviewsAverageRating > 0) {
            return formatValue(product.reviewsAverageRating);
        }
        return 0;
    };
    const handleAddToBag = () => __awaiter(void 0, void 0, void 0, function* () {
        const eligibility = product.checkoutEligibility;
        // If no cart callback provided, just open the retailer page
        if (!onAddToCart) {
            handleViewInStore();
            return;
        }
        if (isServerSideCheckoutEligible(eligibility) && !isAddingToBag) {
            setIsAddingToBag(true);
            try {
                yield onAddToCart(product);
                onOpenCart === null || onOpenCart === void 0 ? void 0 : onOpenCart();
            }
            catch (error) {
                console.error('Error adding to bag:', error);
            }
            finally {
                setIsAddingToBag(false);
            }
        }
    });
    const handleViewInStore = () => {
        const retailerUrl = product.retailerProductPageUrl;
        if (retailerUrl) {
            window.open(retailerUrl, '_blank');
        }
    };
    const reviewRating = getReviewRatingValue();
    const reviewCount = product.reviewsCount || 0;
    const retailerId = product.retailerId || 0;
    const retailerName = product.retailerDisplayName || getRetailerFromId(retailerId);
    const price = product.retailPrice || 0;
    const isEligibleForCheckout = isServerSideCheckoutEligible(product.checkoutEligibility);
    return (React__default.createElement("div", { className: "tw:flex tw:flex-col tw:gap-2" },
        React__default.createElement("h1", { className: "tw:text-base tw:font-semibold tw:text-primary tw:tracking-[0.08px]" }, product.title),
        React__default.createElement("div", { className: "featured-product-grid tw:grid tw:w-full tw:my-2 tw:bg-white" },
            images.length > 0 && React__default.createElement(ProductImageCarousel, { images: images, productTitle: product.title }),
            React__default.createElement("div", { className: "tw:flex tw:flex-col tw:gap-4 tw:p-4" },
                reviewRating > 0 && (React__default.createElement("div", { className: "tw:flex tw:items-center tw:gap-1.5 tw:text-sm tw:font-medium" },
                    React__default.createElement(StarIcon, { className: "tw:size-4" }),
                    React__default.createElement("span", { className: "tw:text-primary", style: { paddingTop: '2px' } },
                        reviewRating,
                        " (",
                        numeral(reviewCount).format('0,0'),
                        " ratings)"))),
                featureBullets.length > 0 && (React__default.createElement("div", { className: "tw:flex tw:flex-col tw:gap-2" },
                    React__default.createElement("h4", { className: "tw:text-base tw:font-semibold tw:text-primary tw:tracking-[0.08px]" }, "Key features"),
                    React__default.createElement("ul", { className: "tw:m-0 tw:pl-[18px] tw:list-disc tw:flex tw:flex-col tw:gap-0.5" }, featureBullets.slice(0, 3).map((bullet, idx) => (React__default.createElement("li", { key: idx, className: "tw:text-xs tw:font-medium tw:text-primary tw:leading-5" }, bullet)))))),
                React__default.createElement("div", { className: "tw:flex tw:flex-col tw:gap-3 tw:mt-auto" },
                    React__default.createElement(Button, { variant: "solid", onClick: handleAddToBag, disabled: isAddingToBag, fullWidth: true, height: 46, sx: {
                            borderRadius: '9999px',
                            gap: '16px',
                            fontSize: '16px',
                            fontWeight: 600,
                            letterSpacing: '0.08px',
                        } },
                        React__default.createElement("span", null, isEligibleForCheckout ? 'Add to bag' : 'View'),
                        React__default.createElement("span", { className: "tw:size-2 tw:rounded-full tw:bg-white" }),
                        React__default.createElement("span", null,
                            retailerName,
                            " ",
                            formatMoney(price))),
                    React__default.createElement(Button, { variant: "outline", onClick: handleViewInStore, fullWidth: true, height: 46, sx: {
                            borderRadius: '9999px',
                            fontSize: '16px',
                            fontWeight: 600,
                            letterSpacing: '0.08px',
                        } }, "View in-store availability"))))));
};

export { FeaturedProductWidget };
//# sourceMappingURL=FeaturedProductWidget.js.map
